import { createReducer, on } from '@ngrx/store';
import * as actions from './se-stepper-side-nav.actions';
import { ISeStepperSideNavChildrenState, SeStepperSideNavParentState, seStepperSideNavChildrenInitialState, seStepperSideNavParentInitialState } from "./se-stepper-side-nav.state";
import { cloneDeep, merge } from "lodash-es";
import { DeepPartial } from "../../utils/types";
import { SeStepperSideNavComponentType } from "../se-stepper-side-nav.models";


// children actions
export const seStepperSideNavChildrenReducer = createReducer(
    seStepperSideNavChildrenInitialState,
    on(actions.seStepperSideNavSetPatient, (state, { patientId }) => setPatient(state, patientId)),
    on(actions.seStepperSideNavNoResult, (state, { message }) => setMessage(state, message)),
    on(actions.seStepperSideNavSetExams, (state, { examId }) => setExam(state, examId)),
    on(actions.seStepperSideNavRemoveExams, (state, { examId }) => removeExam(state, examId))
);


// parent actions
export const seStepperSideNavParentReducer = createReducer(
    seStepperSideNavParentInitialState,
    on(actions.seStepperSideNavComponentSetActiveComponents, (state, { activationList, customProps }) =>
        setActiveComponents(state, activationList, customProps)
    )
);



function setPatient (state : ISeStepperSideNavChildrenState, patientId : string) : ISeStepperSideNavChildrenState {
    return {
        ...state,
        patientId
    };
}

function setExam (state : ISeStepperSideNavChildrenState, examId : string) : ISeStepperSideNavChildrenState {
    return {
        ...state,
        examId
    };
}

function removeExam (state : ISeStepperSideNavChildrenState, examId : string) : ISeStepperSideNavChildrenState {
    return {
        ...state,
        examId
    };
}

function setMessage (state : ISeStepperSideNavChildrenState, message : string) : ISeStepperSideNavChildrenState {
    return {
        ...state,
        message
    }
}

function setActiveComponents (
    state : SeStepperSideNavParentState,
    activationList : SeStepperSideNavComponentType[],
    customProps ?: DeepPartial<SeStepperSideNavParentState>
) : SeStepperSideNavParentState {
    // Resetto tutti gli stati attivi
    let newState = cloneDeep(state);
    for (const key in newState) {
        newState[key].active = false;
    }

    // Imposto attivi quelli passati
    for (const key of activationList) {
        newState[key].active = true;
    }

    return customProps ? merge(newState, customProps) : newState;
}
